<template>
  <BaseLayout @click-back="back" isFunction="true" hasBottomButton="true" hasHeaderBar="true">
    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text">出貨日</div>
      </div>
      <input type="date" class="form-control" v-model="searchData.ShippingDateStartForSearch" />
      <div class="input-group-prepend">
        <div class="input-group-text">~</div>
      </div>
      <input type="date" class="form-control" v-model="searchData.ShippingDateEndForSearch" />
    </div>

    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text">客戶</div>
      </div>
      <input type="text" class="form-control" v-model="searchData.CustomerIdStartForSearch" />
      <div class="input-group-prepend">
        <div class="input-group-text">~</div>
      </div>
      <input type="text" class="form-control" v-model="searchData.CustomerIdEndForSearch" />
    </div>

    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text">出貨單號</div>
      </div>
      <input type="text" class="form-control" v-model="searchData.ShippingNoStartForSearch" />
      <div class="input-group-prepend">
        <div class="input-group-text">~</div>
      </div>
      <input type="text" class="form-control" v-model="searchData.ShippingNoEndForSearch" />
    </div>

    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text">訂單單號</div>
      </div>
      <input type="text" class="form-control" v-model="searchData.OrderNoStartForSearch" />
      <div class="input-group-prepend">
        <div class="input-group-text">~</div>
      </div>
      <input type="text" class="form-control" v-model="searchData.OrderNoEndForSearch" />
    </div>

    <div class="list-group" style="text-align: left;">
      <template v-for="(item,index) in gridData">
        <div
          :key="item.ShippingNo+item.ShippingSeqNo"
          class="list-group-item list-group-item-action"
        >
          <div
            class="d-flex w-100 justify-content-between"
            style=" background:#EEE; padding: 5px 5px 0px 5px"
          >
            <b class="mb-1">
              <!-- <i class="fas fa-building"></i> -->
              出貨單:{{item.ShippingNo}} {{item.ShippingSeqNo}}
            </b>
            <h5
              class="badge badge-success"
              style="width:40%; 
              overflow: hidden;
    white-space: nowrap;
     word-break: break-all;"
            >訂單:{{item.OrderNo}} {{item.SeqNo}}</h5>
          </div>
          <div class="d-flex flex-row justify-content-between">
            <span class="badge badge-light">客戶: {{item.CustomerId}} {{item.CustomerAbbreviation}}</span>
          </div>
          <div class="d-flex flex-row justify-content-between">
            <span class="badge badge-light">料號: {{item.ItemNo}}</span>
          </div>
          <!-- <div class="d-flex flex-row">
            <span class="badge badge-light">品名:{{item.ItemDescription}}</span>
          </div>-->
          <div class="d-flex flex-row">
            <span class="badge badge-light">出貨日:{{item.ShippingDate}}</span>
            <span class="badge badge-light">出貨數量:{{item.ShippingQuantity}}</span>
          </div>
          <!-- <small
            v-if="item.SalesDepartmentId"
            style="color:#888;float:right;"
          >業務部門: {{item.SalesDepartmentId}}</small>-->
          <!-- <small style="float:right; color:#888;">
            <i class="fas fa-user"></i>
            {{form.EmployeeName}}
          </small>-->
        </div>
      </template>
    </div>
    <button @click="query" type="button" class="btn-xl btn btn-primary btn-circle">
      <i class="fas fa-search"></i>
    </button>
  </BaseLayout>
</template>
<script>
export default {
  name: "ShippingDateReport",
  data: function() {
    var today = new Date();

    var data = {
      searchData: {
        CompanyId: this.$store.state.companyId, //"JET",
        ShippingNoStartForSearch: "",
        ShippingNoEndForSearch: "",
        OrderNoStartForSearch: "",
        OrderNoEndForSearch: "",
        ShippingDateStartForSearch: new Date(
          today.getFullYear(),
          today.getMonth(),
          2
        )
          .toISOString()
          .slice(0, 10),
        ShippingDateEndForSearch: new Date().toISOString().slice(0, 10),
        CustomerIdStartForSearch: "",
        CustomerIdEndForSearch: ""
      },
      gridData: []
    };
    return data;
  },
  methods: {
    back: function() {
      this.$router.go(-1);
    },
    query: function() {
      // debugger;
      if (
        !this.searchData.ShippingDateStartForSearch ||
        !this.searchData.ShippingDateEndForSearch
      ) {
        this.setMessageText("未設定出貨日");
        return;
      }
      var _this = this;
      this.startLoad();
      _this.$http
        .post("/WebApp/ShippingDateReport/Query", {
          ...this.searchData
        })
        .then(res => {
          _this.gridData = res.data;
          _this.gridData.forEach(v => {
            let setDate = dateName => {
              if (v[dateName]) {
                var d = new Date(parseInt(v[dateName].substr(6)));
                v[dateName] =
                  d.getFullYear() +
                  "-" +
                  (d.getMonth() + 1) +
                  "-" +
                  d.getDate();
              }
            };
            setDate("ShippingDate");
          });
          _this.endLoad();
        })
        .catch(err => {
          _this.endLoad();
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.btn-circle.btn-xl {
  position: fixed;
  bottom: 10px;
  right: 10px;
  width: 70px;
  height: 70px;
  padding: 10px 16px;
  border-radius: 35px;
  font-size: 24px;
  line-height: 1.33;
}
.btn-circle {
  width: 30px;
  height: 30px;
  padding: 6px 0px;
  border-radius: 15px;
  text-align: center;
  font-size: 12px;
  line-height: 1.42857;
}
.input-group > .input-group-prepend:first-child > .input-group-text {
  width: 5.8rem;
}
input[type="date"] {
  padding: 0;
}
</style>